import { Button, CircularProgress, Stack, TextField } from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { useHistory, Link } from "react-router-dom";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Login.css";

const Login = () => {
  const { enqueueSnackbar } = useSnackbar();

  /**
   * Perform the Login API call
   * @param {{ username: string, password: string }} formData
   *  Object with values of username, password and confirm password user entered to register
   *
   * API endpoint - "POST /auth/login"
   *
   * Example for successful response from backend:
   * HTTP 201
   * {
   *      "success": true,
   *      "token": "testtoken",
   *      "username": "criodo",
   *      "balance": 5000
   * }
   *
   * Example for failed response from backend:
   * HTTP 400
   * {
   *      "success": false,
   *      "message": "Password is incorrect"
   * }
   *
   */
  const[username,setUsername]=useState("");
  const[password,setPassword]=useState("");
  const[apiCall,setApiCall]=useState(false);

  const history = useHistory()
  const handleUsernameChange=(e)=>{
    setUsername(e.target.value)
  }
  const handlePasswordChange=(e)=>{
    setPassword(e.target.value);
  }
  const login = async (formData) => {
    
    const data={"username":username,"password":password}
    const url=config.endpoint+"/auth/login";
    console.log(data)
  try{   await axios.post(url,data)
        .then((response)=>{  persistLogin(response.data.token,response.data.username,response.data.balance); setApiCall(false);  enqueueSnackbar("Logged in successfully")})
        .catch((err)=>{ console.log(err.response.data.message); setApiCall(false); enqueueSnackbar(err.response.data.message)})
  }catch(e){ enqueueSnackbar("Something went wrong please check backend") };

  };

  // TODO: CRIO_TASK_MODULE_LOGIN - Validate the input
  /**
   * Validate the input values so that any bad or illegal values are not passed to the backend.
   *
   * @param {{ username: string, password: string }} data
   *  Object with values of username, password and confirm password user entered to register
   *
   * @returns {boolean}
   *    Whether validation has passed or not
   *
   * Return false and show warning message if any validation condition fails, otherwise return true.
   * (NOTE: The error messages to be shown for each of these cases, are given with them)
   * -    Check that username field is not an empty value - "Username is a required field"
   * -    Check that password field is not an empty value - "Password is a required field"
   */
  const validateInput = (data) => {
    console.log(data.username, data.password);
    if(data.username.length===0)
    {
      enqueueSnackbar("Username is a required field");
      return false;
    }
    if(data.password.length===0)
    {
      enqueueSnackbar("Password is a required field");
      return false;
    }
    return true

  };

  // TODO: CRIO_TASK_MODULE_LOGIN - Persist user's login information
  /**
   * Store the login information so that it can be used to identify the user in subsequent API calls
   *
   * @param {string} token
   *    API token used for authentication of requests after logging in
   * @param {string} username
   *    Username of the logged in user
   * @param {string} balance
   *    Wallet balance amount of the logged in user
   *
   * Make use of localStorage: https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage
   * -    `token` field in localStorage can be used to store the Oauth token
   * -    `username` field in localStorage can be used to store the username that the user is logged in as
   * -    `balance` field in localStorage can be used to store the balance amount in the user's wallet
   */
  const persistLogin = (token, username, balance) => {
    localStorage.setItem('token',token);
    localStorage.setItem('username',username);
    localStorage.setItem('balance',balance);
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="100vh"
    >
      <Header hasHiddenAuthButtons />
      <Box className="content">
        <Stack spacing={2} className="form">
          <h2 className="title">Login</h2>
          <TextField
            id="username"
            label="Username"
            variant="outlined"
            title="Username"
            name="username"
            placeholder="Enter Username"
            fullWidth
            onChange={handleUsernameChange}
          />
           <TextField
            id="password"
            label="Password"
            variant="outlined"
            title="Password"
            name="password"
            placeholder="Enter Password"
            fullWidth 
            onChange={handlePasswordChange}
           />
        { (apiCall===false)? <Button className="button" variant="contained" 
         onClick={(e)=>{ if(validateInput({"username":username,"password":password})); setApiCall(true);  login(e);   history.push("/");  } }>LOGIN TO QKART</Button>:
        <CircularProgress />
        }
          <p className="secondary-action">
            Don't have an account?{" "}
             {/* <a className="link" href="#">
              Register here
             </a> */}
             <Link className="link" to="/register" replace>Register Now</Link>
         {/* //    <Link to="/login" replace>Login here</Link> */}
          </p>
          
        </Stack>
      </Box>
      <Footer />
    </Box>
  );
};

export default Login;
